module.exports = __webpack_public_path__ + "static/media/reseech-decor1.612ad01d.png";